export class UserActivityType {
  constructor(
    public code: number,
    public name: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/user-activity-type.ts